export const compactNumber = (num: number, decimals = 0) => {
	const formatter = new Intl.NumberFormat('en-US', {
		notation: 'compact',
		minimumFractionDigits: 0,
		maximumFractionDigits: decimals || 0,
	});

	return formatter.format(num);
};

export const formatNumber = (num: number) => {
	const formatter = new Intl.NumberFormat('en-US', {
		notation: 'standard',
	});

	return formatter.format(num);
};
